import { LegacyCard } from "@shopify/polaris"
import type { ReactNode } from "react"

interface ModuleCardProps {
  children: ReactNode
}

const ModuleCard = (props: ModuleCardProps) => {
  const { children } = props

  return (
    <LegacyCard sectioned>
      {children}
    </LegacyCard>
  )
}

export default ModuleCard
